import { SxProps, Theme } from "@mui/material";

export const styles = {
  root: {
    width: "100%",
    maxWidth: 500,
    height: 42,
    display: "flex",
    alignItems: "center",
  } as SxProps<Theme>,

  iconWrapper: (bgColor: string): SxProps<Theme> => ({
    width: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: bgColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mt: "14px",
    mb: "8px",
    mr: "12px",
    padding: "4px",
    flexShrink: 0,
  }),

  text: (color: string): SxProps<Theme> => ({
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    color,
  }),
};
